import React from 'react'
import PropTypes from 'prop-types'
import Layout from './layout'

class DefaultLayout extends React.PureComponent {

  render() {
    const {
      actions,
      children,
      layout,
      noComposeButton,
      noRightSidebar,
      page,
      showBackBtn,
      tabs,
      search,
      button,
      title,
      noSidebar,
      sidebarChildren,
      slimLayout,
      noPullToRefresh,
      showNormalSidebar,
    } = this.props

    return (
      <Layout
        slimLayout={slimLayout}
        noSidebar={noSidebar}
        actions={actions}
        layout={layout}
        noComposeButton={noComposeButton}
        noRightSidebar={noRightSidebar}
        showNormalSidebar={showNormalSidebar}
        page={page}
        showBackBtn={showBackBtn}
        tabs={tabs}
        button={button}
        title={title}
        search={search}
        sidebarChildren={sidebarChildren}
        noPullToRefresh={noPullToRefresh}
      >
        {children}
      </Layout>
    )
  }

}

DefaultLayout.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node.isRequired,
  layout: PropTypes.array,
  noComposeButton: PropTypes.bool,
  noRightSidebar: PropTypes.bool,
  slimLayout: PropTypes.bool,
  page: PropTypes.string,
  showBackBtn: PropTypes.bool,
  tabs: PropTypes.array,
  title: PropTypes.string.isRequired,
}

export default DefaultLayout
